module.exports = __webpack_public_path__ + "static/media/PM46.5486b33f.png";